import { c as _c } from "react/compiler-runtime";
import React from 'react';
interface KatanaIconProps {
  className?: string;
}
export function KatanaIcon(t0) {
  const $ = _c(5);
  const {
    className
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <rect width="1000" height="1000" fill="url(#paint0_linear_1963_1461)" />;
    t2 = <path d="M485.626 439.896L609.365 223.965H733.107L640.301 533.027H548.279L795.765 656.652L671.249 843.635L485.626 626.29V780.277H269.076L343.321 533.027H269.076L361.883 223.965H485.626V439.896Z" fill="#F6FF0D" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <defs><linearGradient id="paint0_linear_1963_1461" x1="500" y1="0" x2="500" y2="1416.5" gradientUnits="userSpaceOnUse"><stop offset="0.06" stopColor="#101631" /><stop offset="0.39" stopColor="#0541B2" /><stop offset="0.57" stopColor="#059EED" /><stop offset="0.7" stopColor="#C5EAFC" /></linearGradient></defs>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== className) {
    t4 = <svg viewBox="0 0 1000 1000" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>{t1}{t2}{t3}</svg>;
    $[3] = className;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}